module.exports = __webpack_public_path__ + "img/comment-slash.8d2bdf94.svg";